/** @jsxImportSource preact */
import './app.css'
import { Router, Route, LocationProvider } from 'preact-iso'

import { Home } from './components/Home'
import { LossRecovery } from './components/LossRecovery'
import { ChangeAndCancellation } from './components/ChangeAndCancellation'
import { ASC } from './components/ASC'
import { Fraud } from './components/Fraud'
import { PriceDrift } from './components/PriceDrift'
import { Create } from './components/Create'
import { General } from './components/General'
import { CustomerService } from './components/CustomerService'
import { Payments } from './components/Payments'
import { Etickets } from './components/Etickets'
import { Refunds } from './components/Refunds'
import { BulkRefundClose } from './components/BulkRefundClose'
import { BulkTicketedOutside } from './components/BulkTicketedOutside'
import { RefundProtect } from './components/RefundProtect'
import { RefundScoring } from './components/RefundScoring'
import { RefundSurcharges } from './components/RefundSurcharges'
import { FrontContextProvider } from './providers/front'
import { AuthProvider, useAuth } from './providers/auth'
import { config } from './config'

export function Root() {
  return (
    <LocationProvider>
      <AuthProvider>
        <FrontContextProvider>
          <App />
          <BuildStamp />
        </FrontContextProvider>
      </AuthProvider>
    </LocationProvider>
  )
}

// Sits outside <App/>'s loading guard so it's readable even while auth resolves — the whole point
// is being able to ask an agent "what does the corner say?" at any moment.
function BuildStamp() {
  const builtAt = new Date(__BUILT_AT__)
  const day = builtAt.toLocaleDateString(undefined, { day: '2-digit', month: 'short' })
  const time = builtAt.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })

  return (
    <div
      className="fixed bottom-1 right-2 z-50 font-mono text-[10px] text-gray-400 pointer-events-none select-none"
      title={`${__BUILD_ENV__} build ${__BUILD_SHA__}, built ${builtAt.toLocaleString()}`}
    >
      {__BUILD_ENV__ === 'prod' ? '' : `${__BUILD_ENV__} · `}
      {__BUILD_SHA__} · {day} {time}
    </div>
  )
}

function App() {
  const { isLoading } = useAuth()

  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>
  }

  return (
    <Router>
      <Route
        path={config.routePrefix + '/loss-recovery'}
        component={LossRecovery}
      />
      <Route
        path={config.routePrefix + '/change-and-cancellation'}
        component={ChangeAndCancellation}
      />
      <Route
        path={config.routePrefix + '/asc'}
        component={ASC}
      />
      <Route
        path={config.routePrefix + '/fraud'}
        component={Fraud}
      />
      <Route
        path={config.routePrefix + '/ndc-price-drift'}
        component={PriceDrift}
      />
      <Route
        path={config.routePrefix + '/create'}
        component={Create}
      />
      <Route
        path={config.routePrefix + '/create/bulk-ticketed-outside'}
        component={BulkTicketedOutside}
      />
      <Route
        path={config.routePrefix + '/general'}
        component={General}
      />
      <Route
        path={config.routePrefix + '/customer-service'}
        component={CustomerService}
      />
      <Route
        path={config.routePrefix + '/payments'}
        component={Payments}
      />
      <Route
        path={config.routePrefix + '/etickets'}
        component={Etickets}
      />
      <Route
        path={config.routePrefix + '/refunds'}
        component={Refunds}
      />
      <Route
        path={config.routePrefix + '/refunds/bulk-close'}
        component={BulkRefundClose}
      />
      <Route
        path={config.routePrefix + '/refund-protect'}
        component={RefundProtect}
      />
      <Route
        path={config.routePrefix + '/refunds/scoring'}
        component={RefundScoring}
      />
      <Route
        path={config.routePrefix + '/refunds/surcharges'}
        component={RefundSurcharges}
      />
      <Route
        path={config.routePrefix + '/'}
        component={Home}
      />
    </Router>
  )
}
